import { Component, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { AppserviceService } from 'src/app/appservice.service';
import { NgxSpinnerService } from 'ngx-spinner';

import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { ContentObserver } from '@angular/cdk/observers';

import * as myGlobals from 'src/app/globals';
import $ from 'jquery';

@Component({
  selector: 'app-receipts',
  templateUrl: './receipts.component.html',
  styleUrls: ['./receipts.component.sass']
})
export class ReceiptsComponent implements OnInit {
  AppData$;
  receiptsWO:any = [];
  dataSource = [];
  tabledata = [];
  woIds = [];
  woPartsData:any = [];
  isDisable:boolean = false;
  displayedColumns: string[] = ['No','WO Number','RSL','Parts Avl'];
  consignmentNo:string;
  selectedItem;
  partworkorder:boolean = false;
  consignValid:boolean = false;
  consignValues:any = [];
  partsLength = 0;

  receiptObj = {
    part_code: "",//part.part_id,
    consignment_code: "",//null,
    from_store: "",//part.rsl_code,
    to_store: "",//engineerID,
    from_bin: "",//"GOODSIN",
    qty: 0,//part.part_qty,
    quick_in: 0,//1,
    to_bin: "",//"FEBIN",
    clear_reservations: 1,//1,
    create_reservations:0,
    wo_id: "",//workOrderID
    courierno:""
  };

  receiptUpdateBool:boolean = false;
  receiptUpdateMsg = '';
  receiptUpclass = "";

  @ViewChild(MatSort, {static: true}) sort: MatSort;


  constructor(private AppService :AppserviceService, private route: ActivatedRoute, private router: Router, private spinner:NgxSpinnerService) { 
    //this.fetchAppData();
  }

  refreshView() {
    this.spinner.show();
    this.AppService.fetchAllWos(localStorage.getItem('username')).subscribe((dataObj : any[])=> {
      this.spinner.hide();
      //console.log(dataObj);
      if(Object.keys(dataObj['data']).length > 0){
        this.woIds = Object.keys(dataObj['data']);
        this.dataSource = dataObj['data'];
        //this.woPartsData = this.dataSource[this.woIds[0]];
        this.multPartsWO(this.woIds[0]);
        this.selectedItem = this.woIds[0];
        //console.log(this.selectedItem);
        //this.consignmentNo = "Enter consignment number for part " + this.woPartsData.PART_ID;
        this.disableSection(this.woPartsData);
      }else{
        this.dataSource = [];
      }
    },
    (error) => {
      this.spinner.hide();
    });
  }

  multPartsWO(woData){
    var multArry = [];
    var that = this;
    console.log(woData);
    this.dataSource[woData].forEach(function(value){
      if(value.PART_QTY > 1){
        for(let i=0,j=value.PART_QTY;i<j;i++){
          multArry.push(value);
        }
      }else{
        that.woPartsData.push(value);
      }
    });
    if(multArry.length != 0){
      multArry.forEach(function(value){
        that.woPartsData.push(value);
      });
    }
    this.partsLength = this.woPartsData.length;
    console.log(this.woPartsData);
  }

  validConsign(event, idx){
    var _sV = event.target.value;
    if(_sV.length >= 8){
      this.consignValid = true;
      this.consignValues[idx] = _sV;
      // this.receiptObj['consignment_code'] = _sV;
      this.receiptUpdateBool = false;
    }else{
      this.consignValid = false;
    }
  }

  submitReceipt(itemObj,index){
    //console.log(itemObj,this.dataSource[itemObj['WO']].length );
    /* var objAvailB = false;
    if(this.dataSource[itemObj['WO']].length > 1){
      objAvailB = this.dataSource[itemObj['WO']].forEach(element => {
        if(element.DISABLE === false){
          return false;
        }  
        return true;
      });
    }else{
      objAvailB = (this.dataSource[itemObj['WO']][0].PART_AVAILABLE_QTY>0)?!this.dataSource[itemObj['WO']][0].DISABLE:this.dataSource[itemObj['WO']][0].DISABLE;
    } */

    //if(objAvailB){
      this.receiptObj['part_code'] = itemObj['PART_ID'];
      this.receiptObj['from_store'] = itemObj['RSL_CODE'];
      this.receiptObj['to_store'] = localStorage.getItem('username');
      this.receiptObj['from_bin'] = "GOODSIN";
      this.receiptObj['qty'] = 1;
      this.receiptObj['to_bin'] = "FEBIN";
      this.receiptObj['i_clear_reservations'] = 1;
      this.receiptObj['i_create_reservations'] = 0,
      this.receiptObj['quick_in'] = 1;
      this.receiptObj['wo_id'] = itemObj['WO'];
      //this.receiptObj['consignment_code'] = itemObj['CONSIGNMENT_NO'];
      this.receiptObj['consignment_code'] = this.consignValues[index];
      this.receiptObj['engineer'] = localStorage.getItem('username');
      this.receiptObj['courierno'] = '';
      console.log(this.receiptObj, itemObj);
      this.spinner.show();
      //$('#'+ itemObj['RSL_CODE'] + index).hide();
      this.AppService.issueParts(this.receiptObj).subscribe((dataObj : any[])=> {
          $('#'+ itemObj['RSL_CODE'] + index).hide();
          this.spinner.hide();
          console.log('success');
          //this.refreshView();
          this.receiptUpdateBool = true;
          // this.receiptObj['consignment_code'] = '';
          this.receiptUpdateMsg = "Part receipting successful.";
          this.receiptUpclass = myGlobals.appMessages['classes']['success'];
        },
        (err) => {
          this.spinner.hide();
          this.receiptUpdateBool = true;
          this.receiptUpdateMsg = "Error in receipting the part!";
          this.receiptUpclass = myGlobals.appMessages['classes']['error'];
        }
      );
    //}else{
      //console.log('Multiple items are unavailbale!');
    //}
  }

  disableSection(obj){
    if(obj.length === 1){
      (parseInt(obj.PART_AVAILABLE_QTY) != 0 )? this.isDisable = false : this.isDisable = true;
    }else{

    }
  }

  itemData(event, dataObj, index){
    //console.log(dataObj, index,dataObj+index);
    //document.getElementById('partworkorder').;
    //this.disableSection(dataObj);
    this.selectedItem = dataObj;
    //console.log(this.selectedItem);
    //(this.partworkorder)?!this.partworkorder:this.partworkorder;
    //(parseInt(dataObj.part_available_qty) != 0 )? this.isDisable = false : this.isDisable = true;
    //document.getElementById(dataObj.WO+index).className = 'list-group-item list-group-item-action active';
    //this.woPartsData = this.dataSource[dataObj];
    this.woPartsData = [];
    this.multPartsWO(dataObj);
    //console.log(this.woPartsData);
    //this.consignmentNo = "Enter consignment number for part " + dataObj.PART_ID;
  }
  ngOnInit() {
    //this.fetchAppData();
    //this.tabledata = this.dataSource;
    //this.ngOnDestroy();
    this.refreshView();
  }


}
